 

export const DownloadIcon = ({ fill = "var(--YW_Body_Top_Right_Tab_Icon_Color)"}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M19 9H15V3H9V9H5L12 16L19 9ZM5 18V20H19V18H5Z" fill={fill}/>
</svg>
);

export const downloadIcon = <DownloadIcon />